const ITEMS = [
  "Custom Design",
  "Responsive",
  "AI-Assisted Workflow",
  "Business-Focused",
  "Fast First Drafts",
  "Direct Communication",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      aria-hidden="true"
      className="border-y border-line py-5 md:py-7 overflow-hidden select-none"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-heading italic text-2xl md:text-4xl text-ink/80 whitespace-nowrap px-6 md:px-10">
                  {item}
                </span>
                <span className="text-accent text-lg md:text-2xl">✳</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
